/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * tabSelecter.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
/**
 * ページURL取得
 */
var getPathName = location.pathname;
var pageName = /\/aboutus\//;

/**
 * 初期化 - slideKvXを非表示にする
 */
const initializeTabs = () => {
	const tabTargets = document.querySelectorAll(".js-tab-target");
	for (let i = 0; i < tabTargets.length; i++) {
		tabTargets[i].classList.remove("is-active");
	}
};

/**
 * タブをアクティブにする関数
 */
const activateTab = (tabContainer, tabId) => {
	const tabTriggers = tabContainer.querySelectorAll(".js-tab-trigger");
	const tabTargets = tabContainer.querySelectorAll(".js-tab-target");

	for (let i = 0; i < tabTriggers.length; i++) {
		tabTriggers[i].classList.remove("is-active");
	}
	for (let i = 0; i < tabTargets.length; i++) {
		tabTargets[i].classList.remove("is-active");
	}

	const activeTrigger = tabContainer.querySelector(`.js-tab-trigger[data-id="${tabId}"]`);
	const activeTarget = document.getElementById(tabId);

	if (activeTrigger) {
		activeTrigger.classList.add("is-active");
	}
	if (activeTarget) {
		activeTarget.classList.add("is-active");
	}
};

/**
 * タブ - クリック
 */
const tabSelecterClick = () => {
	const tabContainers = document.querySelectorAll(".js-tabs");

	if (tabContainers.length > 0) {
		tabContainers.forEach((tabContainer) => {
			const tabTriggers = tabContainer.querySelectorAll(".js-tab-trigger");

			for (let i = 0; i < tabTriggers.length; i++) {
				tabTriggers[i].addEventListener("click", (e) => {
					let currentMenu = e.currentTarget;
					let currentContent = document.getElementById(currentMenu.dataset.id);

					for (let i = 0; i < tabTriggers.length; i++) {
						tabTriggers[i].classList.remove("is-active");
					}
					currentMenu.classList.add("is-active");

					const tabTargets = tabContainer.querySelectorAll(".js-tab-target");
					for (let i = 0; i < tabTargets.length; i++) {
						tabTargets[i].classList.remove("is-active");
					}
					if (currentContent !== null) {
						currentContent.classList.add("is-active");
					}
				});
			}

			const hash = window.location.hash;
			const queryString = window.location.search.substring(1);
			if (hash) {
				const tabId = hash.substring(1);
				const activeTarget = document.getElementById(tabId);
				if (activeTarget && tabId !== "access") {
					activateTab(tabContainer, tabId);
				} else {
					const defaultTab = tabTriggers[0].dataset.id;
					activateTab(tabContainer, defaultTab);
				}
			} else if (queryString) {
				activateTab(tabContainer, queryString);
			} else {
				const defaultTab = tabTriggers[0].dataset.id;
				activateTab(tabContainer, defaultTab);
			}
		});
	}
};

/**
 * タブ - ホバー
 */
const tabSelecterHover = () => {
	if (getPathName.match(pageName)) {
		const tabHoverTriggers = document.querySelectorAll(".js-tab-hover-trigger");
		const tabTargets = document.querySelectorAll(".js-tab-target");

		for (let i = 0; i < tabHoverTriggers.length; i++) {
			tabHoverTriggers[i].addEventListener("mouseenter", (e) => {
				let currentMenu = e.currentTarget;
				let currentContent = document.getElementById(currentMenu.dataset.id);

				for (let i = 0; i < tabHoverTriggers.length; i++) {
					tabHoverTriggers[i].classList.remove("is-active");
				}
				currentMenu.classList.add("is-active");

				for (let i = 0; i < tabTargets.length; i++) {
					tabTargets[i].classList.remove("is-active");
				}
				if (currentContent !== null) {
					currentContent.classList.add("is-active");
				}
			});
		}
	}
};

// エクスポート
export { tabSelecterClick };
